import { Link } from "react-router-dom";
import Modal from "react-modal";
import { ReactComponent as ConfirmSvg } from "../../../media/confirm.svg";

export default function ConfirmMealModal({
  showCModal,
  handleCloseCModal,
  selectedMeal,
  selectedDateLabel,
  recipe,
  handleSubmit,
}) {
  return (
    <Modal
      isOpen={showCModal}
      onRequestClose={handleCloseCModal}
      contentLabel="Date Picker Modal"
      className="modal"
      overlayClassName="overlay"
    >
      <div className="modal-header">
        <ConfirmSvg className="marginR30" alt="confirm"></ConfirmSvg>
      </div>
      <div className="modal-body">
        <h2>
          برای {selectedMeal} {selectedDateLabel}، {recipe.recipe_name} میذاری؟
        </h2>
      </div>
      <div className="modal-footer">
        <Link
          to=""
          onClick={handleSubmit}
          className="marginBottom0-4r fill-container radius1-5"
        >
          آره اضافه کن
        </Link>
        <Link
          to=""
          onClick={handleCloseCModal}
          className="b-grey-4 purple-1 fill-container radius1-5"
        >
          منصرف شدم
        </Link>
      </div>
    </Modal>
  );
}
